import { render, staticRenderFns } from "./ModalNewspaper.vue?vue&type=template&id=0cc5f546&scoped=true"
import script from "./ModalNewspaper.vue?vue&type=script&lang=js"
export * from "./ModalNewspaper.vue?vue&type=script&lang=js"
import style0 from "./ModalNewspaper.vue?vue&type=style&index=0&id=0cc5f546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc5f546",
  null
  
)

export default component.exports